import {DeprecatedModuleInitFn, Undef} from 'app/interface';
import {GemSettings} from 'app/utils/config/interface';

import {initURLParametersStorage} from '../storage/initURLParametersStorage';

export function initDeprecated(context: HTMLElement, gemSettings: GemSettings) {
    const removeOnMobile = Array.from(document.querySelectorAll('.is-mobile .js-gem-module-no-mobile'));
    removeOnMobile.forEach((elem) => elem.parentNode?.removeChild(elem));

    const getNotInitializedElementsWithContext = getNotInitializedElements(context);
    const isOnPage = (selector: string, moduleName: string): boolean => {
        return getNotInitializedElementsWithContext(selector, moduleName).length > 0;
    };

    if (isOnPage('.slsp-oauth', 'app/components/slspOauthClient')) {
        import(/* webpackChunkName: "slspOauthClient" */ 'app/components/slspOauthClient').then(({SLSPOauthClient}) => {
            new SLSPOauthClient(document.getElementsByClassName('slsp-oauth')[0]).init();
        });
    }

    initURLParametersStorage(gemSettings);

    const searchCookieElements = getNotInitializedElementsWithContext('meta[name=areaId]', 'modules/search/searchCookie');
    if (searchCookieElements.length) {
        importModule(import(/* webpackChunkName: "searchCookie" */ 'modules/search/searchCookie'), gemSettings, searchCookieElements[0]);
    }

    initDataAttributeComponents(getNotInitializedElementsWithContext, isOnPage, gemSettings);
}

async function importModule<T1 extends Promise<{init?: DeprecatedModuleInitFn<T2>}>, T2>(
    modulePromise: T1,
    gemSettings: GemSettings,
    element: Undef<T2> = undefined,
) {
    const module = await modulePromise;
    module.init?.({element, gemSettings});
}

function initDataAttributeComponents(
    getNotInitializedElementsWithContext: (selector: string, moduleName: string) => HTMLElement[],
    isOnPage: (selector: string, moduleName: string) => boolean,
    gemSettings: GemSettings,
) {
    const selectElements = getNotInitializedElementsWithContext('[data-select]', 'app/components/select');
    if (selectElements.length) {
        importModule(import(/* webpackChunkName: "select" */ 'app/components/select'), gemSettings, selectElements);
    }

    const backBtnElements = getNotInitializedElementsWithContext('[data-back-button]', 'modules/branchAtmSearch/backButton');
    backBtnElements.forEach((element) => {
        importModule(import(/* webpackChunkName: "branchAtmSearchBackButton" */ 'modules/branchAtmSearch/backButtonFactory'), gemSettings, element);
    });

    if (isOnPage('[data-tooltip]', 'modules/tooltip/tooltip')) {
        importModule(import(/* webpackChunkName: "tooltipFactory" */ 'modules/tooltip/tooltipFactory'), gemSettings);
    }
}

const getNotInitializedElements =
    (context: HTMLElement) =>
    (selector: string, moduleName: string): HTMLElement[] => {
        const elements = Array.from(context.querySelectorAll<HTMLElement>(selector));
        const dataAttributeName = `data-initialized-${moduleName.replace(/\//g, '-').toLowerCase()}`;
        return elements
            .filter((element) => !element.hasAttribute(dataAttributeName))
            .map((element) => {
                element.setAttribute(dataAttributeName, 'true');
                return element;
            });
    };
